import { Button, Input, Label, TextArea, TextField } from "@heroui/react";
import type { CreateCharacterInput } from "@storyline/shared";
import { useState } from "react";

type CharacterFormProps = {
	initial?: CreateCharacterInput;
	submitLabel: string;
	onSubmit: (body: CreateCharacterInput) => Promise<void>;
	onCancel?: () => void;
};

const EMPTY: CreateCharacterInput = { name: "", description: "", continuityRules: null, voiceNotes: null };

const CharacterForm: React.FC<CharacterFormProps> = ({ initial, submitLabel, onSubmit, onCancel }) => {
	const [name, setName] = useState(initial?.name ?? EMPTY.name);
	const [description, setDescription] = useState(initial?.description ?? EMPTY.description);
	const [continuityRules, setContinuityRules] = useState(initial?.continuityRules ?? "");
	const [voiceNotes, setVoiceNotes] = useState(initial?.voiceNotes ?? "");
	const [busy, setBusy] = useState(false);

	const submit = async (): Promise<void> => {
		if (name.trim() === "") {
			return;
		}
		setBusy(true);
		try {
			await onSubmit({
				name,
				description,
				continuityRules: continuityRules.trim() === "" ? null : continuityRules,
				voiceNotes: voiceNotes.trim() === "" ? null : voiceNotes,
			});
		} finally {
			setBusy(false);
		}
	};

	return (
		<div className="flex flex-col gap-3 rounded-xl border border-border-soft bg-glass p-4">
			<TextField value={name} onChange={setName}>
				<Label>Nom</Label>
				<Input placeholder="Marc" />
			</TextField>
			<TextField value={description} onChange={setDescription}>
				<Label>Description physique</Label>
				<TextArea placeholder="30 ans, cheveux bruns mi-longs, cicatrice…" rows={2} />
			</TextField>
			<TextField value={continuityRules} onChange={setContinuityRules}>
				<Label>Règles de continuité (optionnel)</Label>
				<TextArea placeholder="Porte toujours sa veste en cuir, œil gauche vairon…" rows={2} />
			</TextField>
			<TextField value={voiceNotes} onChange={setVoiceNotes}>
				<Label>Notes de voix (optionnel, audio non produit)</Label>
				<Input placeholder="Voix grave, débit lent" />
			</TextField>
			<div className="flex justify-end gap-2">
				{onCancel ? (
					<Button size="sm" variant="ghost" onPress={onCancel} className="text-muted">
						Annuler
					</Button>
				) : null}
				<Button size="sm" isDisabled={busy || name.trim() === ""} onPress={() => void submit()}>
					{busy ? "…" : submitLabel}
				</Button>
			</div>
		</div>
	);
};

export default CharacterForm;
